<template>
  <b-modal title="Informações Sobre o Faturamento" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="10">
          <b-form-group label="Cliente:" label-for="cliente" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="cliente" v-model="editing.cliente" />
          </b-form-group>
        </b-col>

        <b-col cols="1">
          <b-form-select v-model="selecionado">
            <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
              >{{ cliente.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="desc" label-cols-sm="3" label-align="right">
            <b-form-textarea v-model="editing.descricao" rows="2"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Orçamento:" label-for="orcamento" label-cols="3" label-align="right">
            <b-form-input id="orcamento" v-model.lazy="editing.orcamento" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Data:" label-for="data" label-cols="3" label-align="right">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Nota Fiscal:" label-for="nota" label-cols="3" label-align="right">
            <b-form-input id="nota" v-model.lazy="editing.nota" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Total:" label-for="total" label-cols="3" label-align="right">
            <b-form-input id="total" v-model.lazy="editing.total" v-money="money" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-checkbox v-model="editing.pago" name="check-button" switch class="pt-2">
            Pagamento Concluído <b>(Checked: {{ editing.pago }})</b>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useFaturamentoStore } from "@/stores/FaturamentoStore";
import { useClienteStore } from "@/stores/ClienteStore";
import Faturamento from "@/models/Faturamento";
import Notificacao from "@/models/Notificacao";
import { VMoney } from "v-money";

export default {
  name: "ModalDeEdicaoDeFaturamento",

  data() {
    return {
      show: false,
      selecionado: null,
      editing: new Faturamento(0, "Novo Faturamento", "", "", new Date(), "", 0.0, false),
      total: Number(0.0),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente.nome;
    },
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.faturamentoStore.ALTERAR_FATURAMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Faturamento salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.editing.setNumber();
          this.$emit("focarItemDaTabela", this.editing);
        });
      } else {
        this.faturamentoStore.CADASTRAR_FATURAMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Faturamento salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      }
      this.show = !this.show;
    },

    call(faturamento) {
      this.show = !this.show;
      this.editing.update(faturamento);
    },
  },

  setup() {
    const store = useSgcqStore();
    const faturamentoStore = useFaturamentoStore();
    const clienteStore = useClienteStore();

    return {
      store,
      faturamentoStore,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
